export default __webpack_public_path__ + "946dfc457d027fdf15879f1e9f127a3e.png";